import React from 'react'
import { useMap, MapProps } from './useMap'

const Map: React.FC<MapProps> = (props: MapProps) => {
  const {} = useMap(props)

  return (
    <div className='row pb-4'>
      <div className='col-12'>
        <iframe
          src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6624.0115119237535!2d35.4891274!3d33.8895056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151f172f6773e1b5%3A0xd0e4b6716f534605!2z2YXYsdmD2LIg2KfZhNiv2LnZiNipINin2YTYpdiz2YTYp9mF2YrYqQ!5e0!3m2!1sen!2sde!4v1735024577604!5m2!1sen!2sde'
          frameBorder='0'
          title='Address'
          style={{
            border: 0,
            width: '100%',
            height: '400px',
            borderRadius: '10px',
          }}
          allowFullScreen
          loading='lazy'
          referrerPolicy='no-referrer-when-downgrade'
        ></iframe>
      </div>
    </div>
  )
}

export default Map
